module.exports = __webpack_public_path__ + "img/virusColectivo3.cee1ba9e.jpg";